const selectors = {
  modal: '[data-modal]',
  modalBackdrop: '[data-modal-backdrop]',
  modalClose: '[data-modal-close]',
  modalOpen: '[data-modal-open]',
  modalVideo: '[data-modal-video]',
  productColumn: '[data-column-id]',
  productCompare: '[data-products-compare]',
  productCompareSelector: '[data-select-col]',
};

const openModal = (modal) => {
  modal.classList.add('active');

  // Lock Body scroll
  document.body.classList.add('modal-open');
};

const closeModal = (modal) => {
  modal.classList.remove('active');

  // Unlock Body scroll
  document.body.classList.remove('modal-open');
};

const selectorChange = (container, currentValue, prevValue) => {
  const columnSelected = container.querySelectorAll(
    '[data-column-id="' + currentValue + '"]',
  );
  const outdatedColumn = container.querySelectorAll(
    '[data-column-id="' + prevValue + '"]',
  );

  // Use the selector's new value to display the new column
  columnSelected.forEach((column, idx) => {
    column.classList.add('active');
    column.style.order = outdatedColumn[idx].style.order;
    outdatedColumn[idx].classList.remove('active');
    outdatedColumn[idx].style.order = '';
  });
};

const saveInitialValue = (select) => {
  select.setAttribute('data-prev-value', select.value);
};

const setPrevValue = (select, prevValue) => {
  select.setAttribute('data-prev-value', prevValue);
};

const updateDisabledOptionsBis = (container, select) => {
  const selectedValues = [];
  const productCompareSelectors = container.querySelectorAll(
    selectors.productCompareSelector,
  );
  productCompareSelectors.forEach((selector) => {
    selector.options.forEach((option) => {
      const column = container.querySelector(
        `.product-column--header[data-column-id="${option.value}"]`,
      );
      if (!option.selected && column?.classList?.contains('active')) {
        option.disabled = true;
      } else {
        option.disabled = false;
      }
    });
  });
};

const addUpdatingState = (productCompare) => {
  productCompare.querySelectorAll('.compare-row').forEach((compareRow) => {
    compareRow.classList.add('updating');
  });
};

const removeUpdatingState = (productCompare) => {
  productCompare.querySelectorAll('.compare-row').forEach((compareRow) => {
    compareRow.classList.remove('updating');
  });
};

const handleProductCompareSelection = () => {
  const productCompareSelector = document.querySelectorAll(
    selectors.productCompareSelector,
  );
  if (productCompareSelector) {
    const productCompares = document.querySelectorAll(selectors.productCompare);
    productCompares.forEach((productCompare) => {
      const productCompareSelector = productCompare.querySelectorAll(
        selectors.productCompareSelector,
      );
      productCompareSelector.forEach((selector) => {
        //Save the selects initial values
        saveInitialValue(selector);

        selector.addEventListener('click', (event) => {
          setPrevValue(selector, selector.value);
        });

        selector.addEventListener('change', (event) => {
          addUpdatingState(productCompare);
          selectorChange(
            productCompare,
            selector.value,
            selector.dataset.prevValue,
          );
          updateDisabledOptionsBis(productCompare, selector);
          selector.value = selector.dataset.prevValue;

          // Timeout not needed, just using it to let the user know 'something' is loading :)
          setTimeout(() => {
            removeUpdatingState(productCompare);
          }, 400);
        });
      });
    });
  }
};

const handleProductCompareModalEvents = () => {
  const productCompares = document.querySelectorAll(selectors.productCompare);
  if (productCompares) {
    productCompares.forEach((productCompare) => {
      const thisProductCompare = productCompare;
      const productColumns = thisProductCompare.querySelectorAll(
        selectors.productColumn,
      );

      productColumns.forEach((productColumn) => {
        const modal = productColumn.querySelector(selectors.modal);

        if (modal) {
          const modalOpen = productColumn.querySelector(selectors.modalOpen);
          const modalClose = productColumn.querySelector(selectors.modalClose);
          const modalBackdrop = productColumn.querySelector(
            selectors.modalBackdrop,
          );
          const modalVideo = productColumn.querySelector(selectors.modalVideo);

          modalOpen.addEventListener('click', (event) => {
            openModal(modal);
          });

          modalClose.addEventListener('click', (event) => {
            closeModal(modal);
            modalVideo.setAttribute('src', modalVideo.getAttribute('src'));
          });
          modalBackdrop.addEventListener('click', (event) => {
            closeModal(modal);
            modalVideo.setAttribute('src', modalVideo.getAttribute('src'));
          });
        }
      });
    });
  }
};

const productCompare = {
  init() {
    handleProductCompareModalEvents();
    handleProductCompareSelection();
  },
};

export default productCompare;
